import React from "react";
import { colors2, SkeletonLoader } from "oolib";
import styled from "styled-components";

const LoadingContainer = styled.div`
  padding: 1.4rem;
  margin: 1rem;
  border-radius: 0.5rem;
  border: 1px solid ${colors2.grey5};
`;

const LoadingHeader = styled.div`
  border-bottom: 1px solid ${colors2.grey5};
  padding-bottom: 1.5rem;
`;

const LoadingFilterItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    border-bottom: none;
  }
`;

const LoadingIcon = styled.div`
  margin-right: 0.75rem;
  flex-shrink: 0;
`;

const LoadingContent = styled.div`
  flex: 1;
`;

export const FiltersLoader = () => {
  return (
    <LoadingContainer>
      {/* Header loading */}
      <LoadingHeader>
        <SkeletonLoader style={{ width: "60%", height: "24px", borderRadius: "0.4rem", marginBottom: "0.5rem" }} />
        <SkeletonLoader style={{ width: "80%", height: "16px", borderRadius: "0.4rem" }} />
      </LoadingHeader>

      {/* Filter items loading */}
      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "45%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "70%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "65%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "55%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "30%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "50%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "60%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "75%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "40%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>

      <LoadingFilterItem>
        <LoadingIcon>
          <SkeletonLoader style={{ width: "20px", height: "20px", borderRadius: "50%" }} />
        </LoadingIcon>
        <LoadingContent>
          <SkeletonLoader style={{ width: "80%", height: "16px", borderRadius: "0.4rem" }} />
        </LoadingContent>
        <SkeletonLoader style={{ width: "16px", height: "16px", borderRadius: "0.2rem" }} />
      </LoadingFilterItem>
    </LoadingContainer>
  );
};
